import { zodResolver } from "@hookform/resolvers/zod";
import { useCallback, useState } from "react";
import { useForm } from "react-hook-form";

import { Button } from "~/components/Button";
import { TextInput } from "~/components/TextInput";
import { insertToast } from "~/modules/toasts/services";
import { api } from "~/utils/api";

import { type FormValues, schema } from "./schema";

export const RequestRecoverPasswordForm: React.FC = () => {
	const {
		handleSubmit,
		register,
		formState: { errors },
	} = useForm<FormValues>({
		resolver: zodResolver(schema),
	});

	const [state, setState] = useState({
		sent: false,
		loading: false,
	});

	const onSubmit = useCallback(async (payload: FormValues) => {
		setState((state) => ({ ...state, loading: true }));

		await api.post("/personal-trainers/authenticate/recover-password", payload);

		insertToast({
			title: "E-mail enviado",
			message: "Verifique sua caixa de entrada",
			duration: 5,
		});
		setState(() => ({ sent: true, loading: false }));
	}, []);

	return (
		<form className="flex flex-col gap-4" onSubmit={handleSubmit(onSubmit)}>
			<h3 className="text-2xl mb-2">Recupere sua senha</h3>

			{state.sent ? (
				<p className="bg-gpa-blue-50 py-2 px-4 rounded-md">
					Você receberá um e-mail contendo um link para definir sua nova senha,
					verifique sua caixa de spam caso o e-mail não apareça na sua caixa de
					entrada.
				</p>
			) : null}

			<TextInput
				{...register("email")}
				label="Seu e-mail cadastrado no GPA"
				error={errors.email?.message}
			/>

			<Button loading={state.loading}>Solicitar troca de senha</Button>
		</form>
	);
};
